var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.545 17.5653C10.8346 17.2383 10.986 16.8735 10.9991 16.4711C11.0123 16.0686 10.8609 15.7164 10.545 15.4145L3.87043 9.0377L10.5845 2.62313C10.8741 2.34642 11.0123 1.98796 10.9991 1.54774C10.986 1.10753 10.8346 0.749066 10.545 0.472359C10.2027 0.145341 9.82748 -0.0118788 9.41937 0.000698756C9.01127 0.0132764 8.64924 0.170496 8.33328 0.472359L0.473931 7.98119C0.315954 8.13212 0.197473 8.29563 0.118484 8.47171C0.0394955 8.6478 0 8.83646 0 9.0377C0 9.23895 0.0394955 9.42761 0.118484 9.6037C0.197473 9.77978 0.315954 9.94329 0.473931 10.0942L8.29379 17.5653C8.60974 17.8672 8.97835 18.0118 9.39963 17.9992C9.8209 17.9867 10.2027 17.842 10.545 17.5653Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/collapse-arrow.45e1fef8ee13911f36b48cf699d11432.svg";
export { ForwardRef as ReactComponent };